<template>
  <div>
    <page-header
      title="Add User"
      breadcrumb="Dashboard > Users and Groups > Add User"
    />
    <div class="custom-card" v-loading="loading">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader
                  @input="handleImageUpload($event)"
                  @remove-image="removeImage"
                  :imageUrl="newUser.imageUrl"
                  :isUploadingImage="isUploadingImage"
                />
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">First Name </label>
                <input
                  type="text"
                  class="input"
                  v-model="newUser.firstname"
                  placeholder="-- Enter First Name --"
                />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Middle Name</label>
                <input
                  type="text"
                  class="input"
                  v-model="newUser.middlename"
                  placeholder="-- Enter Middle Name --"
                />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">Last Name</label>
                <input
                  type="text"
                  class="input"
                  v-model="newUser.lastname"
                  placeholder="-- Enter Last Name --"
                />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Gender</label>
                <el-select v-model="newUser.gender" placeholder="-- Select --">
                  <el-option
                    v-for="gender in genders"
                    :key="gender"
                    :label="gender"
                    :value="gender"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Work Email</label>
                <base-input
                  class="input"
                  v-model="newUser.email"
                  placeholder="Please Enter Your Email"
                  errorText="Please enter a valid email Address"
                  :validation="
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                      newUser.email
                    )
                  "
                >
                  <template v-slot:icon>
                    <svg
                      width="19"
                      height="14"
                      viewBox="0 0 19 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.941 0.283447H1.96132C1.63025 0.283447 1.31273 0.417552 1.07863 0.656259C0.84453 0.894966 0.713013 1.21872 0.713013 1.55631V11.7392C0.713013 12.0768 0.84453 12.4005 1.07863 12.6392C1.31273 12.8779 1.63025 13.012 1.96132 13.012H16.941C17.272 13.012 17.5896 12.8779 17.8237 12.6392C18.0578 12.4005 18.1893 12.0768 18.1893 11.7392V1.55631C18.1893 1.21872 18.0578 0.894966 17.8237 0.656259C17.5896 0.417552 17.272 0.283447 16.941 0.283447ZM15.5678 1.55631L9.45114 5.8713L3.33445 1.55631H15.5678ZM1.96132 11.7392V2.13546L9.09538 7.16962C9.19986 7.24352 9.32398 7.28313 9.45114 7.28313C9.5783 7.28313 9.70243 7.24352 9.80691 7.16962L16.941 2.13546V11.7392H1.96132Z"
                        fill="#FCC210"
                      />
                    </svg>
                  </template>
                </base-input>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input v-model="newUser.mobile_no"></vue-tel-input>
                <div v-if="isValidPhone && newUser.mobile_no.length > 0">
                      <p class="text-red-600">
                        Phone number must be numeric values only
                      </p>
                    </div>
                    <div v-if="isValidPhoneLength && newUser.mobile_no.length > 0">
                      <p class="text-red-600">
                        Phone number must be 11 characters long
                      </p>
                    </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label for="employment-type" class="label">Employment Type</label>
            <el-select v-model="newUser.employmentType" placeholder="">
              <el-option
                value=""
                >-- Select --
              </el-option>
              <el-option
                v-for="employmentType in employmentTypes"
                :key="employmentType"
                :label="employmentType"
                :value="employmentType"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <div class="new-user-form-location-and-priviledge-form">
          <div class="container-fluid">
            <h3 class="w-full mb-6 font-semibold">Locations & Privileges</h3>
            <div class="row mb-4">
              <div class="col-md-6 col-lg-4 col-12">
                <label class="label flex justify-between items-center">Role
                  <span class="text-primary-yellow cursor-pointer" @click="$router.push('/settings/roles-and-privileges')">View Privileges</span>
                </label>
                
                <el-select
                  filterable
                  v-model="selectedRole"
                  placeholder=""
                >
                  <el-option
                    value=""
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="role in roles"
                    :key="role.id"
                    :value="role.id"
                    :label="role.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-6 col-lg-4 col-12" id="fleet">
                <label class="label">Fleet</label>

                <el-select
                  filterable
                  v-model="newUser.fleet"
                  placeholder=""
                >
                  <el-option
                    value=""
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="fleet in fleets"
                    :key="fleet.id"
                    :value="fleet.id"
                    :label="fleet.equipment + '/' + fleet.chassisnumber"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="col-md-6 col-lg-4 col-12">
         
                <label class="label flex justify-between items-center">Location
                  <span><i class="default-point"></i>Default</span>
                </label>
                <el-select
                  multiple
                  filterable
                  @remove-tag="removeLocation($event)"
                  v-model="selectedLocation"
                  placeholder=""
                 
                >
                  <el-option
                    value="--Select--"
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="location in routes"
                    :key="location.id"
                    :label="location.locationName"
                    :value="location.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
           
              <div class="row">
              <div class="pb-3 mb-5 flex justify-end w-full" v-if="isDriverOrDispatcher">
                <span 
                @click="showDriversLicence = true"
                class="text-primary-green flex items-center cursor-pointer">
                  <img src="./plus.svg" class="mr-1"/>
                  Add Driver’s License</span>
              </div>
              
              <div class="mb-12" v-if="hasLicence">
                <div class="flex items-center shadow-md bg-white py-2">
                  <div class="col-2"> <img
                    style="width: 70px"
                    src="@/assets/images/icons/documents.svg"
                  /></div>
                  <div class="col-6">
                    <span class="font-semibold"><a class="anchor" :href="newUser.driverLicense.url">License.pdf</a></span>
                    <span class="w-full inline-block">Licenses • {{itemSize}}KB</span>
                    <span>Expires: {{ formatDate(newUser.driverLicense.expirydate) }}</span>
                  </div>
                  <div class="col-4 flex justify-between">
                      <span class="w-12 h-12 inline-flex rounded-md justify-center items-center bg-gray-200 cursor-pointer"
                       @click="viewLicense">
                        <img src="./assets/eye.svg" class="mr-1"/></span>
                      <span class="w-12 h-12 inline-flex rounded-md justify-center items-center bg-gray-200 cursor-pointer"
                      @click="editDriverLicence"
                      >
                        <img src="./assets/pencil.svg" class="mr-1"/></span>
                      <span class="w-12 h-12 inline-flex rounded-md justify-center items-center bg-gray-200 cursor-pointer"
                      @click="deleteLicence"
                      ><img src="./assets/delete.svg" class="mr-1"/></span>
                  </div>
                </div>
              </div>
              </div>

    
            </div>
         
        </div>
        <div v-if="show">
          <advanced-details-form />
        </div>
      </div>
      <div class="flex items-center justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <primary-button
          buttonText="Add User"
          @click="createUser"
          :loading="creatingUser"
        />
      </div>
    </div>
    <DriversLicenseModal
    :showModal="showDriversLicence"
    @close-modal="closeDriversModal"
    @licenseDetail="licenseDetail"
    :resetDriverLicense="resetDriverLicense"
    :isView="isView"
    />
  </div>
</template>

<script>
import AdvancedDetailsForm from "@/components/3pl/Users/AdvancedDetailsForm";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import PageHeader from "@/components/UI/NewPageHeader";
import DriversLicenseModal from "./component/DriversLicenseModal.vue"
import moment from "moment"

export default {
  components: {
    AdvancedDetailsForm,
    PageHeader,
    ImageUploader,
    DriversLicenseModal
  },
  data() {
    return {
      endDate: "",  
      show: false,
      routes: [],
      orgRoute: [],
      showDriversLicence: false,
      isView: false,
      selectedRole: "",
      additionalInfo: [
        {
          selectedRoute: "",
          selectedFleet: "",
          route: "",
        },
      ],
      selectedLocation: [],
      selectedRoute: [],
      fleets: [],
      index: 0,
      loading: true,
      newUser: {
        firstname: "",
        middlename: "",
        lastname: "",
        gender: "",
        email: "",
        mobile_no: "",
        employmentType: "",
        roles: {},
        additionalInfo: [],
        // fleet: "",
        fleet: null,
        driverLicense: {}
      },

      optimaRole: "",
      genders: ["Male", "Female"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: null,
      isUploadingImage: false,
      resetDriverLicense: false,
      itemSize: 0,
      newVehicle: {
        orgId: localStorage.getItem("organizationId"),
        driverId: null,
        id: null
      },
    };
  },
  watch: {
    selectedRole(val){
     this.setUserRoles(val)
    },
    "newUser.email"() {
      let { email } = this.newUser;
      if (email.indexOf("@") >= 0 && email.indexOf(".") >= 0) {
        let start = email.indexOf("@") + 1;
        let end = email.indexOf(".");
        let emailClient = email.slice(start, end);
        if (emailClient == "gmail" || emailClient == "yahoo") {
          if (!this.privateEmailConfirmed) {
            this.showModal = true;
          }
        }
      }
    },
  },
  computed: {
         dateFilterpayload() {
          return {
            dateFilter: "custom",
            startDate: "2024-01-01",
            endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
          };
        },
    isDriverOrDispatcher(){
      return (this.newUser?.roles?.roleName?.toLowerCase()?.includes("driver") || this.newUser?.roles?.roleName?.toLowerCase()?.includes("dispatcher"))
    },
    hasLicence(){
     return Object.keys(this.newUser.driverLicense).length > 0
    },
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
    isValidEmail() {
      let validate =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return validate.test(this.newUser.email);
    },
    isValidPhone() {
      let phone = this.newUser.mobile_no;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.newUser.mobile_no.replace(/\s+/g, "").length != 11
        ? true
        : false;
    },
  },
  methods: {
    viewLicense(){
    this.isView = true
    this.showDriversLicence = true
    },
    closeDriversModal(){
      this.isView = false;
      this.showDriversLicence = false
    },
  
    formatDate(val){
        return moment(val).format('DD/MM/YYYY')
    },
    editDriverLicence(){
      this.resetDriverLicense = false
      this.showDriversLicence = true
    },
    setUserRoles(event){
      let role = this.roles.find(x => x.id == event)
      this.newUser.roles = {
        roleId : event,
        roleName: role.name
      }
    },
    deleteLicence(){
      this.resetDriverLicense = true
      this.newUser.driverLicense = {}
    },
    licenseDetail(val){
      this.newUser.driverLicense = val?.data
      this.itemSize = val?.size
    },
    async getFleets() {
      this.loading = true;
      try {
        let response = await this.$_getAllFleets();
        this.fleets = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getRoles() {
       this.loading = true;
      try {
        let response = await this.$_getRoles(this.dateFilterpayload);
        this.roles = response.data.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getRoutes() {
      this.loading = true;
      try {
        let response = await this.$_getAllRoutes();
        this.orgRoutes = response?.data?.data?.shippingServices.filter(
          (route) =>
            route.terminalType != "terminal-to-door" &&
            route.terminalType != "door-to-door"
        );
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getAllLocations() {
      try {
        let response = await this.$_getAll3plLocations();
        this.routes = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },

    async createUser() {
      this.creatingUser = true;

      try {
        let additionalInfo = [];
        additionalInfo.push(
          this.additionalInfo.map((info) => info.selectedRoute)
        );
        // console.log(additionalInfo)

        let userDetails = {
          email: this.newUser.email,
          orgId: localStorage.getItem("organizationId"),
          firstname: this.newUser.firstname, 
          lastname: this.newUser.lastname,
          mobile_no: this.newUser.mobile_no,
          // role: this.newUser.roles.roleId,
          // imageUrl: this.newUser.imageurl,
           middlename: this.newUser.middlename,
           gender: this.newUser.gender,
          // driverLicense: this.newUser.driverLicense,
           employmentType: this.newUser.employmentType,
           role: {
              appSlug: "muleex",
             roleId: this.newUser.roles.roleId,
            // appSlug: "humanar"        
          //   roleName: this.newUser.roles.roleName,         
           },
           locations: this.selectedLocation,
          fleet: this.newUser.fleet,
          routes: this.selectedRoute,
        };
        const response = await this.$_createUser(userDetails);

        console.log(response);
        this.onCreateUser(response.data.data.id);
        
      } catch (error) {
        this.handleError(error);
        this.creatingUser = false;
      }
    },
    onCreateUser() {
    // onCreateUser(userId) {
      this.creatingUser = false;
      // this.updateVehicleDetails(userId)
      this.generateToast("User has successfully been created", "success");
      this.resetUser();
      this.$store.dispatch("resetUserList");
      this.$router.go(-1)
    },
    // async updateVehicleDetails(driverId) {
    //   this.updateVehicle = true;
    //   this.newVehicle.driverId = driverId
    //   this.newVehicle.id = this.newUser.fleet

    //   const payload = {
    //     ...this.newVehicle,
    //   };

    //   await this.$_updateFleet(this.newVehicle.id, payload);
    // },
    resetUser() {
      this.newUser = {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        roles: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newUser.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newUser.imageurl = null;
    },
  },
  async mounted() {
    await this.getAllLocations();
    await this.getRoles();
    await this.getRoutes();
    await this.getFleets();
    // await this.getCreateUserRole()
  },
};
</script>

<style scoped>
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}

.picture-upload-form__img-wrapper {
  position: relative;
}

.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}

.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}

.picture-upload-form__meta {
  padding-top: 1rem;
}

.label {
  font-size: 0.9rem;
}

.input {
  margin-bottom: 0.5rem;
}

.new-user-form__col-three {
  padding-top: 1.25rem;
}

hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}

.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }

  .input-row div {
    width: 100%;
  }
}
.default-point{
   width: 10px;
   height: 10px;
   display: inline-block;
   @apply rounded-full bg-primary-yellow mr-1;
}
.anchor{
  color: inherit
}
</style>
